
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { 
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { CampaignFormValues } from "./types/formTypes";

interface DismissToggleProps {
  form: UseFormReturn<CampaignFormValues>;
}

const DismissToggle: React.FC<DismissToggleProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="allow_dismiss"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">Sluiten toestaan</FormLabel>
            <FormDescription>
              Kan de gebruiker de modal sluiten zonder quiz af te ronden?
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default DismissToggle;
